var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" This is a Routen page ")])
}
var staticRenderFns = []

export { render, staticRenderFns }